import React, { useEffect } from "react";
import logoImg from "../../assets/images/marriott-logo.png";
import styles from "./ConsentPlayfulPage.module.css";
import classNames from "classnames";
import { useLayoutStore } from "../../store";
export const ConsentPlayfulPage = ({ handleConsentChoice, loading }) => {
  const { setShowFooter, setShowHeader } = useLayoutStore();

  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth < 580;
      queueMicrotask(() => {
        setShowFooter(true);
        setShowHeader(!isMobile);
      });
    };

    // Set initial state
    handleResize();

    // Add resize listener
    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <section className={styles.container}>
      <div className={styles.imagesContainer}>
        <img
          className={styles.image}
          src="https://cache.marriott.com/is/image/marriotts7prod/rz-snarz-balcony-ocean-views-19031?wid=720&fit=constrain"
          alt="Positive"
        />
        <div className={styles.imagesTextContainer}>
          <p className={classNames(styles.imagesText, styles.leftAlign)}>
            <svg
              className={styles.leftArrow}
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M12 3.67505L11.655 4.00505L6.43502 9.24005C6.29252 9.3563 6.2269 9.54192 6.26815 9.72192C6.3094 9.90005 6.45002 10.0407 6.62815 10.0819C6.80815 10.1232 6.99377 10.0575 7.11002 9.91505L11.52 5.50505V19.68C11.5181 19.8525 11.6081 20.0138 11.7581 20.1019C11.9081 20.1882 12.0919 20.1882 12.2419 20.1019C12.3919 20.0138 12.4819 19.8525 12.48 19.68V5.50505L16.89 9.91505C17.0063 10.0575 17.1919 10.1232 17.3719 10.0819C17.55 10.0407 17.6906 9.90005 17.7319 9.72192C17.7731 9.54192 17.7075 9.3563 17.565 9.24005L12.345 4.00505L12 3.67505Z"
                fill="black"
              />
            </svg>
            This?
          </p>
          <p className={styles.imagesTextSeparator}>or</p>
          <p className={classNames(styles.imagesText, styles.rightAlign)}>
            That?
            <svg
              className={styles.rightArrow}
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M12 20.1665L12.345 19.8365L17.565 14.6015C17.7075 14.4853 17.7731 14.2996 17.7319 14.1196C17.6906 13.9415 17.55 13.8009 17.3719 13.7596C17.1919 13.7184 17.0063 13.784 16.89 13.9265L12.48 18.3365L12.48 4.1615C12.4819 3.989 12.3919 3.82775 12.2419 3.73963C12.0919 3.65338 11.9081 3.65338 11.7581 3.73963C11.6081 3.82775 11.5181 3.989 11.52 4.1615L11.52 18.3365L7.11002 13.9265C6.99377 13.784 6.80815 13.7184 6.62815 13.7596C6.45002 13.8009 6.3094 13.9415 6.26815 14.1196C6.2269 14.2996 6.29252 14.4853 6.43502 14.6015L11.655 19.8365L12 20.1665Z"
                fill="black"
              />
            </svg>
          </p>
        </div>
        <img
          className={styles.image}
          src="https://cache.marriott.com/is/image/marriotts7prod/pdt-Woman-Traveler-In-Airport-193229829466936?wid=720&fit=constrain"
          alt="Negative"
        />
      </div>

      <main className={styles.main}>
        <img className={styles.logo} src={logoImg} alt="Marriott logo" />
        <h2 className={styles.mainTitle}>Don’t Be the One Who Misses Out</h2>
        <p className={styles.mainText}>
          Opt in. Get the good stuff. No regrets.
        </p>
        <div className={styles.buttonArea}>
          {loading ? (
            <div className={styles.loadingState}>
              <svg
                className={styles.spinner}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                  strokeOpacity="0.3"
                />
                <path
                  d="M12 2a10 10 0 0 1 10 10"
                  stroke="currentColor"
                  strokeWidth="4"
                  strokeLinecap="round"
                />
              </svg>
              <span className={styles.loadingText}>
                Saving your preferences...
              </span>
            </div>
          ) : (
            <>
              <button
                className={classNames(
                  styles.primaryButton,
                  "custom_click_track",
                )}
                data-custom_click_track_value={`Consent Playful|'Send Me The Good Stuff' button|internal`}
                onClick={() => handleConsentChoice(true)}
                type="button"
              >
                Send Me the Good Stuff
              </button>
              <button
                className={classNames(
                  styles.secondaryButton,
                  "custom_click_track",
                )}
                data-custom_click_track_value={`Consent Playful|'I'm not interested' button|internal`}
                onClick={() =>
                  (window.location.href = "https://www.marriott.com")
                }
                type="button"
              >
                I&apos;m not interested
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M8.6333 8.24267L5.3333 4.94267L6.27597 4L10.5186 8.24267L6.27597 12.4853L5.3333 11.5427L8.6333 8.24267Z"
                    fill="#1C1C1C"
                  />
                </svg>
              </button>
            </>
          )}
        </div>
        <p className={styles.textFooter}>
          By clicking the button above, you agree to receive interest-based ads
          from Marriott and Advertising Partners on Marriott channels and
          Advertising Partners&apos; platforms.
        </p>
      </main>
    </section>
  );
};
